<template>
  <div
    class="consolidated-shipment-dials flex flex-gap-1 justify-content-around align-items-center"
  >
    <ConsolidatedShipmentDial
      id="handling-unit-dial"
      :value="numHandlingUnits"
      label="Count"
      :uom-label="handlingUnit"
      :max="MAX_HANDLING_UNITS"
      :tooltip="
        t('multistop.maxHandlingUnitParam', { param: MAX_HANDLING_UNITS })
      "
    />

    <ConsolidatedShipmentDial
      id="weight-dial"
      :value="weight"
      label="Weight"
      :uom-label="t(`uoms.weight.abbreviations.${weightUom}`, weight)"
      :max="MAX_LBS"
      :tooltip="t('multistop.maxWeightParam', { param: MAX_LBS })"
    />

    <ConsolidatedShipmentDial
      id="linear-dial"
      :value="linear"
      label="Linear Feet"
      :uom-label="t(`uoms.length.abbreviations.${linearUom}`)"
      :max="MAX_LINEAR_FEET"
      :tooltip="t('multistop.maxLinearParam', { param: MAX_LINEAR_FEET })"
    />

    <ConsolidatedShipmentDial
      id="volume-dial"
      :value="volume"
      label="Volume"
      :uom-label="t(`uoms.volume.abbreviations.${volumeUom}`)"
      :max="MAX_CUBIC_FEET"
      :tooltip="t('multistop.maxVolumeParam', { param: MAX_CUBIC_FEET })"
    />
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import ConsolidatedShipmentDial from '@/components/shipmentPlanning/consolidation/ConsolidatedShipmentDial.vue';

const MAX_LBS = 40000;
const MAX_HANDLING_UNITS = 52;
const MAX_LINEAR_FEET = 53;
const MAX_CUBIC_FEET = 3816;

const props = defineProps({
  numHandlingUnits: {
    type: Number,
    default: () => 0,
  },
  weight: {
    type: Number,
    default: () => 0,
  },
  linear: {
    type: Number,
    default: () => 0,
  },
  volume: {
    type: Number,
    default: () => 0,
  },
  handlingUnit: {
    type: String,
    default: undefined,
  },
  weightUom: {
    type: String,
    default: undefined,
  },
  linearUom: {
    type: String,
    default: undefined,
  },
  volumeUom: {
    type: String,
    default: undefined,
  },
});
const {
  numHandlingUnits,
  weight,
  linear,
  volume,
  handlingUnit,
  weightUom,
  linearUom,
  volumeUom,
} = toRefs(props);

const { t } = useI18n();
</script>
